/**
 * CenteredColumnLayout
 *
 * Structural layout component that horizontally centers its children
 * using Bootstrap's grid system. Side columns act as responsive spacers.
 *
 * Props:
 * - children: content to be rendered in the center column
 * - centerClass: Bootstrap column classes for the center content
 * - rowClass: optional extra classes for the row container
 */
import React, { useState } from 'react';

const CenteredColumnLayout = ({children, centerClass = "col-10 col-sm-6",sidesClass = "col-1 col-sm-3",  rowClass = "",}) => {

  return (
    <div className={`centeredColumnLayout row p-0 mx-0 my-3 ${rowClass}`}>
    
      
      <div className={`${sidesClass} m-0 p-0`} />

      {/* inner column */}
      <div className={`${centerClass} d-flex flex-column justify-content-center align-items-center p-0 m-0`}>
        {children}
      </div>

      <div className={`${sidesClass} m-0 p-0`} />

    </div>

  );
};

export default CenteredColumnLayout;
